import {Component} from '@angular/core';
import {LoadingController, NavController, NavParams, Platform} from 'ionic-angular';
import {SaleOrderProvider} from "../../providers/sale-order/sale-order";
import {PartOverviewPage} from "../part-overview/part-overview";
import {WorkReportsPage} from "../work-reports/work-reports";
import {VehiclePage} from "../vehicle/vehicle";
import {FileOpener} from "@ionic-native/file-opener";
import {File} from "@ionic-native/file";
import {DocumentViewer, DocumentViewerOptions} from "@ionic-native/document-viewer";

/**
 * Generated class for the SaleOrderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-sale-order',
  templateUrl: 'sale-order.html',
})
export class SaleOrderPage {
  name: any;
  salesOrder: any = {};
  isConfirmed: any = false;
  wasWorkInstructionOpened: any = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private salesOrderProvider: SaleOrderProvider,
    private loadingCtrl: LoadingController,
    private file: File,
    private fileOpener: FileOpener,
    private document: DocumentViewer,
    private plt: Platform
  ) {
    this.name = this.navParams.get('name');

    // if (!this.name)
    //   this.name = 'A000136';
  }

  async ionViewDidEnter() {
    let loading = this.loadingCtrl.create({content: "Sales orders werden geladen, bitte warten ..."});
    loading.present();

    this.salesOrder = await this.salesOrderProvider.get(this.name);
    this.loadConfirmed();

    loading.dismiss();
  }

  async confirmWorkInstruction() {
    let loading = this.loadingCtrl.create({content: "Auftrag wird bestätigt."});
    loading.present();
    await this.salesOrderProvider.confirm(this.name);
    this.isConfirmed = true;
    loading.dismiss();
  }

  async loadConfirmed() {
    let status = await this.salesOrderProvider.getConfirmed(this.name);
    // @ts-ignore
    this.isConfirmed = (status.count > 0);
    this.wasWorkInstructionOpened = this.isConfirmed;
  }

  showWorkInstruction() {
    this.wasWorkInstructionOpened = true;

    let downloadPDF: any = this.salesOrder.work_instructions;
    fetch('data:application/pdf;base64,' + downloadPDF,
      {
        method: "GET"
      }).then(res => res.blob()).then(blob => {
      let filename = this.salesOrder.name + '-work_instruction.pdf';
      let folder = this.file.externalApplicationStorageDirectory;
      if (this.plt.is('ios')) folder = this.file.dataDirectory;

      this.file.writeFile(folder, filename, blob, {replace: true}).then(res => {
        //let location = res.toInternalURL();
        let url = res.toInternalURL();
        let location = folder + filename;

        this.fileOpener.open(
          location,
          'application/pdf'
        ).then((res) => {

        }).catch(err => {
          alert("Arbeitsanweisung konnte nicht geöffnet werden. Fehler: " + err);
        });
      }).catch(err => {
        alert("Arbeitsanweisung konnte nicht gespeichert werden. Fehler: " + err);
      });
    }).catch(err => {
      alert("Arbeitsanweisung konnte nicht geladen werden. Fehler: " + err);
    });
  }

  goToPartOverview() {
    this.navCtrl.push(PartOverviewPage, {salesOrder: this.salesOrder})
  }

  goToWorkReports() {
    this.navCtrl.push(WorkReportsPage, {salesOrder: this.salesOrder})
  }

  goToVehicles() {
    this.navCtrl.push(VehiclePage, {salesOrder: this.salesOrder})
  }

}



// WEBPACK FOOTER //
// ./src/pages/sale-order/sale-order.ts